// extracted by mini-css-extract-plugin
export default {"tag-input":"EditDiagramTagsDialog_tag-input__KNaps"};